import { Divider, Collapse, List } from 'antd';

const { Panel } = Collapse;

const OverviewTabTripjack = ({ hotelDetails }) => {

    let details = {};
    try {
        details = JSON?.parse(hotelDetails?.hotel?.des) || {};
    } catch (error) {
        console.error("Failed to parse JSON:", error);
    }

    return (
        <div className="overview">
            <h4 className="mb-4">Hotel Description</h4>
            <p>
                {Object.entries(details).map(([key, value]) => (
                    <div key={key} style={{ marginBottom: '20px' }}>
                        <h4>{key.replace('_', ' ').toUpperCase()}</h4>
                        <p>{value}</p>
                    </div>
                ))}
            </p>

            <Divider />
            <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                {hotelDetails?.hotel?.inst?.length > 0 ? (
                    hotelDetails.hotel.inst.map((item, index) => {
                        let messageData;
                        try {
                            messageData = JSON.parse(item.msg);
                        } catch (error) {
                            console.error("Error parsing JSON", error);
                            return null;
                        }
                        return (
                            <div
                                key={index}
                                style={{
                                    marginBottom: '20px',
                                    padding: '15px',
                                    borderRadius: '8px',
                                    border: '1px solid #e0e0e0',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                    backgroundColor: '#fff'
                                }}
                            >
                                <h3 style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                    {icons[item.type]} <span style={{ marginLeft: '10px' }}>{item.type.replace('_', ' ')}</span>
                                </h3>
                                <Collapse accordion>
                                    {Object.entries(messageData).map(([key, value], idx) => (
                                        <Panel header={key.replace(/_/g, ' ')} key={idx}>
                                            <List
                                                dataSource={value.split('.').filter(Boolean)}
                                                renderItem={text => <List.Item>{text.trim()}</List.Item>}
                                            />
                                        </Panel>
                                    ))}
                                </Collapse>
                            </div>
                        );
                    })
                ) : null}
            </div>
        </div>
    );
};

export default OverviewTabTripjack;